module.exports = __webpack_public_path__ + "static/media/css.291ef85c.svg";